import React, { useState } from "react";
import { observer } from "mobx-react";
import { useStore } from "./hooks/use-store";
import LoggedIn from "./pages/routers/logged-in";
import LoggedOut from "./pages/routers/logged-out";
import { AuthState } from "./stores/ui/auth-store/auth-store";
// import Header from "./components/header/header";

import "./App.scss";
// import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { Notifications } from '@mantine/notifications';
// import Invite from "./features/invite";
import {
  ColorScheme,
  ColorSchemeProvider,
  MantineProvider,
} from "@mantine/core";
import { PostHogProvider } from "posthog-js/react";
import { ModalsProvider } from "@mantine/modals";

function App() {
  const rootStore = useStore();
  const {
    uiStore: { authStore },
  } = rootStore;

  const [colorScheme, setColorScheme] = useState<ColorScheme>("dark");
  const toggleColorScheme = (value?: ColorScheme) =>
    setColorScheme(value || (colorScheme === "dark" ? "light" : "dark"));

  return (
    <ColorSchemeProvider
      colorScheme={colorScheme}
      toggleColorScheme={toggleColorScheme}
    >
      <MantineProvider
        theme={{
          other: {
            // background: 'rgba(16, 16, 16, 1)'
          },
          colorScheme,
          fontFamily: "Mulish",
        }}
        withGlobalStyles
        withNormalizeCSS
      >
        <ModalsProvider>
          <PostHogProvider
            apiKey={'phc_xtwI2lgu6RVDRLxHxMhdAasEgDsISrKeJmRGU8n40oC'}
            options={{
              session_recording: {
                // WARNING: Only enable this if you understand the security implications
                recordCrossOriginIframes: true,
              },
              api_host: 'https://eu.i.posthog.com',
              person_profiles: 'always'
            }}
          >
            <Router>
              <Switch>
    
                {authStore.authState === AuthState.LoggedIn ? (
                  <LoggedIn />
                ) : (
                  <LoggedOut />
                )}


              </Switch>
            </Router>
          </PostHogProvider>
        </ModalsProvider>
        <Notifications position="top-center"/>
      </MantineProvider >
    </ColorSchemeProvider >
  );
}

export default observer(App);
